import { FunctionComponent, useState, FormEvent } from 'react'
import styled from 'styled-components'
import Button from '../../Button/Button'
import Paragraph from '../../Paragraph/Paragraph'

const StyledButton = styled(Button)`
  padding: 0.5rem 1rem;
  width: auto;
  line-height: 1.8;
`

const RadioLabel = styled.label`
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 1.125rem;
  font-weight: 700;
  user-select: none;

  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    &:checked {
      ~ span span {
        background-color: var(--blue);
        &:hover {
          background-color: var(--blueDark);
        }
      }
      ~ span:hover {
        border: 2px solid var(--blueDark);
      }

      &:focus {
        ~ span {
          border: 2px solid var(--blueDark);
        }
      }
    }
    &:focus {
      ~ span {
        border: 3px solid var(--blue);
      }
    }
  }
`

const Checkmark = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 1.5rem;
  width: 1.5rem;
  border-radius: 50%;
  border: 2px solid var(--blue);
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: transparent;
  span {
    display: block;
    border-radius: 50%;
    width: 1rem;
    height: 1rem;
  }
  &:hover {
    border: 3px solid var(--blue);
  }
`

interface CookieFormProps {
  closeModal: () => void
}

const CookieForm: FunctionComponent<CookieFormProps> = ({ closeModal }) => {
  const [selectedOption, setSelectedOption] = useState<string>()
  const formSubmit = (evt: FormEvent) => {
    evt.preventDefault()
    if (selectedOption) {
      localStorage.setItem('enabledCookies', selectedOption)
      closeModal()
    }
  }
  return (
    <form onSubmit={formSubmit} style={{ marginTop: '6px' }}>
      <div>
        <RadioLabel>
          <input
            type="radio"
            name="cookie-preference"
            value="analytical"
            checked={selectedOption === 'analytical'}
            onChange={() => setSelectedOption('analytical')}
          />
          <Checkmark>
            <span />
          </Checkmark>
          Analytisch
        </RadioLabel>
        <Paragraph style={{ margin: '8px 0 24px 35px' }}>
          Deze cookies laten zien hoe u de website gebruikt. Wij weten dan welke delen van de
          website interessant zijn en welke niet, of de website goed werkt en hoe we de website
          kunnen verbeteren.
        </Paragraph>
      </div>
      <div className="radio">
        <RadioLabel>
          <input
            type="radio"
            name="cookie-preference"
            value="basic"
            checked={selectedOption === 'basic'}
            onChange={() => setSelectedOption('basic')}
          />
          <Checkmark>
            <span />
          </Checkmark>
          Basis
        </RadioLabel>
        <Paragraph style={{ margin: '8px 0 24px 35px' }}>
          Deze cookies zijn nodig om de website te laten functioneren en instellingen of voorkeuren
          vast te houden tijdens een bezoek aan de website of tot een volgend bezoek. Dit soort
          cookies worden op deze website automatisch geplaatst.
        </Paragraph>
      </div>
      <StyledButton type="submit" disabled={selectedOption === undefined}>
        Akkoord en opslaan
      </StyledButton>
    </form>
  )
}

export default CookieForm
